import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
export function ScarcityBar() {
  const [spots, setSpots] = useState(9);
  useEffect(() => {
    if (spots <= 4) return;
    const id = window.setTimeout(() => setSpots(prev => prev - 1), 26000);
    return () => window.clearTimeout(id);
  }, [spots]);
  const total = 120;
  const taken = total - spots;
  const percent = Math.round(taken / total * 100);
  return <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-4" data-id="element-222" data-mp="2b56xyrdpzrl5">
      <div className="flex items-start gap-2" data-id="element-223" data-mp="2g6w8m5x1638p">
        <FlameIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" aria-hidden="true" data-id="element-224" data-mp="2g3gtx479qw7t" />
        <p className="text-[13px] font-bold leading-snug text-amber-900" data-id="element-225" data-mp="274vdpfp9rta7">
          Quedan solo{' '}
          <span className="tabular-nums" data-id="element-226" data-mp="eypky03enph">{spots} cupos</span> con el precio
          promocional de lanzamiento
        </p>
      </div>
      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-amber-200/70" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos ocupados con precio promocional" data-id="element-227" data-mp="5cgzaqlxp6yj">
        <div className="h-full rounded-full bg-amber-500 transition-all duration-700" style={{
        width: `${percent}%`
      }} data-id="element-228" data-mp="3dd7o023aam74" />
      </div>
      <p className="mt-2 text-[11.5px] font-semibold uppercase tracking-wide text-amber-800" data-id="element-229" data-mp="38foaj4eeudg8">
        {taken} de {total} cupos ya reservados · {percent}% completado
      </p>
    </div>;
}